export default "__VITE_ASSET__489b7ad0__"